import React, { useEffect, useState } from "react";
import { Button, Card, Empty, Progress, Typography } from "@douyinfe/semi-ui";
import { radius, sp } from "../styles";

const { Title, Text, Paragraph } = Typography;

const PROCESSING_STAGES = [
  { label: "聚合本周通话与跟进数据", icon: "📊" },
  { label: "规则评估，识别问题标签", icon: "⚙️" },
  { label: "LLM 深度诊断与行动设计", icon: "🧠" },
];

export const ProcessingView: React.FC = () => {
  const [stage, setStage] = useState(0);

  useEffect(() => {
    const t = window.setInterval(() => {
      setStage((s) => (s < PROCESSING_STAGES.length - 1 ? s + 1 : s));
    }, 8000);
    return () => window.clearInterval(t);
  }, []);

  const pct = Math.round(((stage + 1) / PROCESSING_STAGES.length) * 100);

  return (
    <Card
      style={{ marginBottom: sp.lg, borderRadius: radius.md }}
      bodyStyle={{ padding: sp.xxl, textAlign: "center" }}
    >
      <div style={{ marginBottom: sp.lg }}>
        <Progress
          width={60}
          percent={pct}
          type="circle"
          size="large"
          showInfo
          stroke="var(--semi-color-primary)"
        />
      </div>
      <Title heading={5} style={{ marginBottom: sp.lg }}>
        AI 助手分析中…
      </Title>

      <div
        style={{
          maxWidth: 360,
          margin: "0 auto",
          textAlign: "left",
          display: "flex",
          flexDirection: "column",
          gap: sp.sm,
        }}
      >
        {PROCESSING_STAGES.map((s, i) => {
          const active = i === stage;
          const done = i < stage;
          return (
            <div
              key={i}
              style={{
                display: "flex",
                alignItems: "center",
                gap: sp.sm,
                opacity: active || done ? 1 : 0.5,
                fontWeight: active ? 600 : 400,
              }}
            >
              <span style={{ fontSize: 18 }}>
                {done ? "✅" : active ? <span className="semi-icon-spin">⏳</span> : s.icon}
              </span>
              <span style={{ color: active ? "var(--semi-color-primary)" : undefined }}>
                {s.label}
              </span>
            </div>
          );
        })}
      </div>

      <Text type="tertiary" size="small" style={{ marginTop: sp.lg, display: "block" }}>
        通常 30 秒 ~ 2 分钟，请勿关闭页面
      </Text>
    </Card>
  );
};

interface EmptyProps {
  onGenerate: () => void;
}

export const EmptyView: React.FC<EmptyProps> = ({ onGenerate }) => (
  <Card
    style={{ marginBottom: sp.lg, borderRadius: radius.md }}
    bodyStyle={{ padding: sp.xxl }}
  >
    <Empty
      title="本周尚未生成报告"
      description="AI 助手会分析你的通话、跟进、抗拒点，给出本周诊断与具体行动建议。"
      style={{ padding: sp.xl }}
    />
    <div style={{ textAlign: "center", marginTop: sp.md }}>
      <Button theme="solid" type="primary" size="large" onClick={onGenerate}>
        生成本周报告
      </Button>
    </div>
  </Card>
);

interface FailedProps {
  message?: string | null;
  onRetry: () => void;
}

export const FailedView: React.FC<FailedProps> = ({ message, onRetry }) => (
  <Card
    style={{
      marginBottom: sp.lg,
      borderRadius: radius.md,
      border: "1px solid var(--semi-color-danger)",
      background: "var(--semi-color-danger-light-default)",
    }}
    bodyStyle={{ padding: sp.lg, textAlign: "center" }}
  >
    <div style={{ fontSize: 32, marginBottom: sp.sm }}>⚠️</div>
    <Title heading={5} style={{ color: "var(--semi-color-danger)", marginBottom: sp.sm }}>
      生成失败
    </Title>
    <Paragraph type="tertiary" style={{ marginBottom: sp.lg }}>
      {message || "未知错误"}
    </Paragraph>
    <Button theme="solid" type="danger" size="large" onClick={onRetry}>
      重新生成
    </Button>
  </Card>
);
